export const playerGkEventsParams = [
  {
    actions: [
      {
        id: 173,
        lexic_id: 318,
        title: 'Goals conceded',
      },
      {
        id: 161,
        lexic_id: 324,
        title: 'Goal Mistakes',
      },
      {
        id: 162,
        lexic_id: 556,
        title: 'Grave Mistakes',
      },
      {
        id: 14,
        lexic_id: 326,
        title: 'On-Ball Events',
      },
      {
        id: 15,
        lexic_id: 550,
        title: 'On-Ball Events +',
      },
      {
        id: 17,
        lexic_id: 552,
        title: 'On-Ball Events -',
      },
      {
        id: 19,
        lexic_id: 328,
        title: 'Fouls',
      },
      {
        id: 20,
        lexic_id: 554,
        title: 'Fouls Suffered',
      },
      {
        id: 21,
        lexic_id: 104,
        title: 'Yellow Cards',
      },
      {
        id: 22,
        lexic_id: 555,
        title: 'Yellow-Red Cards',
      },
      {
        id: 23,
        lexic_id: 103,
        title: 'Red Cards',
      },
    ],
    id: 1,
    lexic_id: 549,
    title: 'General',
  },
  {
    actions: [
      {
        id: 171,
        lexic_id: 769,
        title: 'Opponent\'s shots',
      },
      {
        id: 172,
        lexic_id: 770,
        title: 'Opponent\'s shots on target',
      },
      {
        id: 174,
        lexic_id: 772,
        title: 'Saved shots',
      },
      {
        id: 176,
        lexic_id: '',
        title: 'Super Saves',
      },
      {
        id: 196,
        lexic_id: 773,
        title: 'GK bouncing saves',
      },
      {
        id: 196,
        lexic_id: 774,
        title: 'GK bouncing saves +',
      },
      {
        id: 199,
        lexic_id: 775,
        title: 'GK bouncing saves -',
      },
      {
        id: 177,
        lexic_id: 776,
        title: 'Penalties faced',
      },
      {
        id: 178,
        lexic_id: 777,
        title: 'Penalty goals conceded',
      },
      {
        id: 179,
        lexic_id: 778,
        title: 'Penalties saved',
      },
    ],
    id: 2,
      lexic_id: 1123,
    title: 'Shots / Saves',
  },
  {
    actions: [
      {
        id: 181,
        lexic_id: 779,
        title: 'GK Interceptions',
      },
      {
        id: 182,
        lexic_id: 780,
        title: 'GK Interceptions +',
      },
      {
        id: 184,
        lexic_id: 781,
        title: 'GK Interceptions -',
      },
      {
        id: 160,
        lexic_id: 641,
        title: 'Clearances',
      },
    ],
    id: 3,
      lexic_id: 1124,
    title: 'GK Actions',
  },
  {
    actions: [
      {
        id: 35,
        lexic_id: 19,
        title: 'Passes',
      },
      {
        id: 36,
        lexic_id: 578,
        title: 'Passes +',
      },
      {
        id: 38,
        lexic_id: 580,
        title: 'Passes -',
      },
      {
        id: 40,
        lexic_id: 722,
        title: 'Passes into duel',
      },
      {
        id: 41,
        lexic_id: 723,
        title: 'Passes into duel +',
      },
      {
        id: 43,
        lexic_id: 724,
        title: 'Passes into duel -',
      },
      {
        id: 186,
        lexic_id: 782,
        title: 'GK Hand Passes',
      },
      {
        id: 187,
        lexic_id: 783,
        title: 'GK Hand Passes +',
      },
      {
        id: 189,
        lexic_id: 784,
        title: 'GK Hand Passes -',
      },
      {
        id: 90,
        lexic_id: 592,
        title: 'Passes Recieved',
      },
      {
        id: 191,
        lexic_id: 786,
        title: 'GK Goal Kick Passes',
      },
      {
        id: 192,
        lexic_id: 796,
        title: 'GK Goal Kick Passes +',
      },
      {
        id: 194,
        lexic_id: 787,
        title: 'GK Goal Kick Passes -',
      },
    ],
    id: 4,
    lexic_id: 19,
    title: 'Passes',
  },
  {
    actions: [
      {
        id: 55,
        lexic_id: 664,
        title: 'Short Passes',
      },
      {
        id: 56,
        lexic_id: 665,
        title: 'Short Passes +',
      },
      {
        id: 58,
        lexic_id: 667,
        title: 'Short Passes -',
      },
      {
        id: 60,
        lexic_id: 669,
        title: 'Medium Passes',
      },
      {
        id: 61,
        lexic_id: 670,
        title: 'Medium Passes +',
      },
      {
        id: 63,
        lexic_id: 672,
        title: 'Medium Passes -',
      },
      {
        id: 65,
        lexic_id: 674,
        title: 'Long Passes',
      },
      {
        id: 66,
        lexic_id: 675,
        title: 'Long Passes +',
      },
      {
        id: 68,
        lexic_id: 677,
        title: 'Long Passes -',
      },
      {
        id: 97,
        lexic_id: 679,
        title: 'Short Passes Received',
      },
      {
        id: 99,
        lexic_id: 681,
        title: 'Medium PassesReceived',
      },
      {
        id: 101,
        lexic_id: 683,
        title: 'Long Passes Received',
      },
    ],
    id: 5,
    lexic_id: 663,
    title: 'Passes by distance',
  },
  {
    actions: [
      {
        id: 70,
        lexic_id: 685,
        title: 'Passes Onward',
      },
      {
        id: 71,
        lexic_id: 686,
        title: 'Passes Onward +',
      },
      {
        id: 73,
        lexic_id: 688,
        title: 'Passes Onward -',
      },
      {
        id: 75,
        lexic_id: 690,
        title: 'Passes Rearward',
      },
      {
        id: 76,
        lexic_id: 691,
        title: 'Passes Rearward +',
      },
      {
        id: 78,
        lexic_id: 693,
        title: 'Passes Rearward -',
      },
      {
        id: 80,
        lexic_id: 695,
        title: 'Passes Sideways',
      },
      {
        id: 81,
        lexic_id: 696,
        title: 'Passes Sideways +',
      },
      {
        id: 83,
        lexic_id: 698,
        title: 'Passes Sideways -',
      },
      {
        id: 103,
        lexic_id: 700,
        title: 'Passes Onward Received',
      },
      {
        id: 105,
        lexic_id: 702,
        title: 'Passes Rearward Received',
      },
      {
        id: 107,
        lexic_id: 704,
        title: 'Passes Sideways Received',
      },
    ],
    id: 6,
    lexic_id: 706,
    title: 'Passes by side',
  },
];
